import ProductBase from './base';
import focusHelper from '../components/focus';

const base = new ProductBase();

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#quickViewModal').length !== 0) {
      $('#quickViewModal').remove();
    }
    const htmlString =
      '<!-- Modal -->' +
      '<div class="modal fade" id="quickViewModal" role="dialog">' +
      '<span class="enter-message sr-only" ></span>' +
      '<div class="modal-dialog modal-dialog-centered quick-view-dialog">' +
      '<!-- Modal content-->' +
      '<div class="modal-content">' +
      '<div class="modal-header">' +
      '    <a class="full-pdp-link" href=""></a>' +
      '    <button type="button" class="btn-close" data-dismiss="modal" aria-label="Close"></button>' +
      '</div>' +
      '<div class="modal-body"></div>' +
      '<div class="modal-footer"></div>' +
      '</div>' +
      '</div>' +
      '</div>';
    $('body').append(htmlString);
  }

/**
 * @typedef {Object} QuickViewHtml
 * @property {string} body - Main Quick View body
 * @property {string} footer - Quick View footer content
 */

/**
 * Parse HTML code in Ajax response
 *
 * @param {string} html - Rendered HTML from quickview template
 * @return {QuickViewHtml} - QuickView content components
 */
function parseHtml(html) {
    const $html = $('<div>').append($.parseHTML(html));

    const body = $html.find('.product-quickview');
    const footer = $html.find('.modal-footer').children();

    return { body, footer };
}

/**
 * replaces the content in the modal window on for the selected product variation.
 * @param {string} selectedValueUrl - url to be used to retrieve a new product model
 */
function fillModalElement(selectedValueUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: selectedValueUrl,
        method: 'GET',
        dataType: 'json',
        success(data) {
            const parsedHtml = parseHtml(data.renderedTemplate);

            $('#quickViewModal .modal-body').empty();
            $('#quickViewModal .modal-body').html(parsedHtml.body);
            $('#quickViewModal .modal-footer').html(parsedHtml.footer);
            $('#quickViewModal .full-pdp-link').text(data.quickViewFullDetailMsg);
            $('#quickViewModal .full-pdp-link').attr('href', data.productUrl);
            $('#quickViewModal .size-chart').attr('href', data.productUrl);
            $('#quickViewModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#quickViewModal .enter-message').text(data.enterDialogMessage);
            $('#quickViewModal').modal('show');

            $.spinner().stop();
        },
        error() {
            $.spinner().stop();
        },
        complete() {
          $('body').trigger('quickview:ready');
        }
    });
}

export default class {
    init() {
        this.showQuickview();
        this.focusQuickview();
        this.trapQuickviewFocus();
        base.availability();
        base.addToCart();
        this.showSpinner();
        this.hideDialog();
        this.beforeUpdateAttribute();
        this.updateAttribute();
        this.updateAddToCart();
        this.updateAvailability();
    }

    showQuickview() {
        $('body').off('click', '.quickview');
        $('body').on('click', '.quickview', function (e) {
            e.preventDefault();
            const selectedValueUrl = $(this).closest('button.quickview').attr('data-href');
            if (!selectedValueUrl) selectedValueUrl = $(this).closest('input.quickview-url').attr('value');
            $(e.target).trigger('quickview:show');
            getModalHtmlElement();
            fillModalElement(selectedValueUrl);
        });
    }

    focusQuickview() {
        $('body').on('shown.bs.modal', '#quickViewModal', () => {
            $('#quickViewModal .close').focus();
        });
    }

    trapQuickviewFocus() {
        $('body').on('keydown', '#quickViewModal', (e) => {
            const focusParams = {
                event: e,
                containerSelector: '#quickViewModal',
                firstElementSelector: '.full-pdp-link',
                lastElementSelector: '.add-to-cart-global',
                nextToLastElementSelector: '.modal-footer .quantity-select',
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    }

    showSpinner() {
        $('body').on('product:beforeAddToCart', (e, data) => {
            $(data).closest('.modal-content').spinner().start();
        });
    }

    hideDialog() {
        $('body').on('product:afterAddToCart', () => {
            $('#quickViewModal').modal('hide');
        });
    }

    beforeUpdateAttribute() {
        $('body').on('product:beforeAttributeSelect', () => {
            $('.modal.show .modal-content').spinner().start();
        });
    }

    updateAttribute() {
        $('body').on('product:afterAttributeSelect', (e, response) => {
            if ($('.modal.show .product-quickview>.bundle-items').length) {
                $('.modal.show').find(response.container).data('pid', response.data.product.id);
                $('.modal.show').find(response.container)
                    .find('.product-id').text(response.data.product.id);
            } else if ($('.set-items').length) {
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.modal.show .product-quickview').data('pid', response.data.product.id);
                $('.modal.show .full-pdp-link')
                    .attr('href', response.data.product.selectedProductUrl);
            }
        });
    }

    updateAddToCart() {
        $('body').on('product:updateAddToCart', (e, response) => {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr('disabled',
                (!response.product.readyToOrder || !response.product.available));

            // update global add to cart (single products, bundles)
            const dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            $('.add-to-cart-global', dialog).attr('disabled',
                !$('.global-availability', dialog).data('ready-to-order')
                || !$('.global-availability', dialog).data('available'));
        });
    }

    updateAvailability() {
        $('body').on('product:updateAvailability', (e, response) => {
            // bundle individual products
            $('.product-availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);

            const dialog = $(response.$productContainer)
                .closest('.quick-view-dialog');

            if ($('.product-availability', dialog).length) {
                // bundle all products
                const allAvailable = $('.product-availability', dialog).toArray()
                    .every((item) => $(item).data('available'));

                const allReady = $('.product-availability', dialog).toArray()
                    .every((item) => $(item).data('ready-to-order'));

                $('.global-availability', dialog)
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg', dialog).empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            } else {
                // single product
                $('.global-availability', dialog)
                    .data('ready-to-order', response.product.readyToOrder)
                    .data('available', response.product.available)
                    .find('.availability-msg')
                    .empty()
                    .html(response.message);
            }
        });
    }
}
